import { Route, Routes } from "react-router-dom";
import About from "./components/About";
import AllProductPage from "./components/AllProductPage";
import ProductListPage from "./components/ProductListPage";

/* Promotion */
import Promo2026_Rose_Momentum from "./components/Promotions/EmailBlast/2026_Rose_Momentum";
import Promo2026_Mulberry_Momentum from "./components/Promotions/EmailBlast/2026_Mulberry_Momentum";
import Promo2026_Allmomentum from "./components/Promotions/EmailBlast/2026_AllMomentum";
import Promo2026_ScrubCaps from "./components/Promotions/EmailBlast/2026_ScrubCaps";
import Promo2026_Apr_Momentum_Labcoats from "./components/Promotions/EmailBlast/2026_Apr_Momentum_Labcoats";
import Promo2026_AllLabCoats from "./components/Promotions/EmailBlast/2026_AllLabCoats";
import Promo2026_Embrace_NewColors from "./components/Promotions/EmailBlast/2026_Embrace_NewColors";
import Promo2026_JAN_SCRUPCAPS from "./components/Promotions/EmailBlast/2026_JAN_SCRUPCAPS";
import Promo2026_Valentines_NEW_DROPS from "./components/Promotions/EmailBlast/2026_Valentines_NEW_DROPS";
import Promo2026_ALLJACKET from "./components/Promotions/EmailBlast/2026_ALLJACKETS";
import Promo2026_NM003_NB004 from "./components/Promotions/EmailBlast/2026_NB003_NB004";
import PromoMomentum_5005_5094_2026 from "./components/Promotions/EmailBlast/2026Momentum_5005_5094";
import PromoNewReadyGoSpringcolors2026 from "./components/Promotions/EmailBlast/New_ReadyGo_Spring_colors_2026";
import PromoMatrixJacketDec2024 from "./components/Promotions/EmailBlast/MatrixJacket_Dec2024";
import PromoMomentumJacketDec2024 from "./components/Promotions/EmailBlast/MomentumJacket_Dec2024";
import PromoRedPandaJacketDec2024 from "./components/Promotions/EmailBlast/RedPandaJacket_Dec2024";
import PromoMOMENTUMAug2024 from "./components/Promotions/EmailBlast/MOMENTUM";
import PromoMATRIXJul2024 from "./components/Promotions/EmailBlast/MATRIX_Jul2024";
import PromoEONJul2024 from "./components/Promotions/EmailBlast/EON_Jul2024";
import PromoEONMATRIXDec2024 from "./components/Promotions/EmailBlast/EON_MATRIX_Dec2024";
import PromoReadyGoJul2024 from "./components/Promotions/EmailBlast/ReadyGo_Jul2024";
import PromoNewSpringColors01 from "./components/Promotions/MainBanner/New_Spring_Colors_01";
import PromoSpringPrints02 from "./components/Promotions/MainBanner/Spring_Prints_02";
import PromoSpringPrints03 from "./components/Promotions/MainBanner/Spring_Prints_03";
import PromoEasterColors from "./components/Promotions/MainBanner/Easter_Colors";
import PromoEON from "./components/Promotions/SubBanner/EON";
import PromoMomentumMensFocus from "./components/Promotions/EmailBlast/Momentum_Mens_Focus_Sep2024";
import PromoJacket from "./components/Promotions/EmailBlast/Jackets_Nov2024";
import PromoBlackFridayReadyGo from "./components/Promotions/EmailBlast/BlackFriday_ReadyGo_Nov2024";
import PromoBlackFriday2024 from "./components/Promotions/MainBanner/BlackFriday_2024_1";
import PromoMomentumDec2024 from "./components/Promotions/EmailBlast/Momentum_Dec2024";
import PromoDec2024 from "./components/Promotions/EmailBlast/Promo_Dec2024";
import PromoReadyGo_NB003_1 from "./components/Promotions/EmailBlast/ReadyGo_NB003_1";
import PromoMatrixPro_MatrixProMens from "./components/Promotions/MainBanner/MatrixPro_MatrixProMens";
import PromoMomentumSpringColors2025 from "./components/Promotions/EmailBlast/MomentumSpringColors2025";
import PromoSpringPastels2025 from "./components/Promotions/EmailBlast/SpringPastels2025";
import PromoAllNewDrops2025 from "./components/Promotions/EmailBlast/AllNewDrops2025";
import PromoAllLabcoats2025 from "./components/Promotions/EmailBlast/Momentun_New_Colors_Spring_Summer_2026";
import PromoEmbrace2025_1 from "./components/Promotions/EmailBlast/Embrace2025_1";
import PromoEmbrace2025_2 from "./components/Promotions/EmailBlast/Embrace2025_2";
import PromoEmbrace2025_3 from "./components/Promotions/EmailBlast/Embrace2025_3";
import PromoEmbrace2025_4 from "./components/Promotions/EmailBlast/Embrace2025_4";
import PromoEmbrace2025_5 from "./components/Promotions/EmailBlast/Embrace2025_5";
import PromoMensJune2025 from "./components/Promotions/EmailBlast/MensJune2025";
import PromoSummerColors2025 from "./components/Promotions/EmailBlast/SummerColors2025";
import PromoSummerPrints2025 from "./components/Promotions/EmailBlast/SummerPrints2025";
import PromoAllMomentum2025 from "./components/Promotions/EmailBlast/AllMomentum2025";
import PromoAllMomentum_Womens_Mens2025 from "./components/Promotions/EmailBlast/AllMomentum_Womens_Mens2025";
import PromoMomentum_Embrace2025 from "./components/Promotions/EmailBlast/Momentum_Embrace2025";
import PromoMomentum_newColor2025 from "./components/Promotions/EmailBlast/newColorMomentum2025";
import Promo_Bestee_Matrix_momentum_2025 from "./components/Promotions/EmailBlast/Promo_Bestee_Matrix_momentum_2025";
import Momentun_New_Colors_Spring_Summer_2026 from "./components/Promotions/EmailBlast/Momentun_New_Colors_Spring_Summer_2026";
import MatrixPro2025 from "./components/Promotions/EmailBlast/MatrixPro2025";
import JACKETS10 from "./components/Promotions/EmailBlast/JACKETS10";
import JACKETS35 from "./components/Promotions/EmailBlast/JACKETS35";
import PromoDecember2025 from "./components/Promotions/EmailBlast/PromoDecember2025";

/* Scrubs */
import Bestee from "./components/Collections/Bestee";
import Blaze from "./components/Collections/Blaze";
import BlazeLite from "./components/Collections/BlazeLite";
import EaseLoungewear from "./components/Collections/EaseLoungewear";
import Blossom from "./components/Collections/Blossom";
import BlossomSignature from "./components/Collections/BlossomSignature";
import Core from "./components/Collections/Core";
import EON from "./components/Collections/EON";
import EONSport from "./components/Collections/EONSport";
import Knits from "./components/Collections/Knits";
import LabCoats from "./components/Collections/LabCoats";
import MatrixUnderscrub from "./components/Collections/MatrixUnderscrub";
import Matrix from "./components/Collections/Matrix";
import MatrixBasic from "./components/Collections/MatrixBasic";
import MatrixImpulse from "./components/Collections/MatrixImpulse";
import MatrixMens from "./components/Collections/MatrixMens";
import MatrixPro from "./components/Collections/MatrixPro";
import MatrixProMens from "./components/Collections/MatrixProMens";
import Momentum from "./components/Collections/Momentum";
import MomentumMens from "./components/Collections/MomentumMens";
import MomentumLabCoats from "./components/Collections/MomentumLabCoats";
import PrimaFlex from "./components/Collections/PrimaFlex";
import Focus from "./components/Collections/Focus";
import Prints from "./components/Collections/Prints";
import PureSoft from "./components/Collections/PureSoft";
import RedPanda from "./components/Collections/RedPanda";
import Smart from "./components/Collections/Smart";
import TRUTC from "./components/Collections/TRUTC";
import Embrace from "./components/Collections/Embrace"; 


/* Accesories */
import PPEProducts from "./components/Accessories/PPEProducts";
import ScrubCap from "./components/Accessories/ScrubCap";
import ScrunchieDuo from "./components/Accessories/ScrunchieDuo";
import Mask from "./components/Accessories/Mask";

/* Bags */
import ReadyGO from "./components/Bags/ReadyGO";
import ReadyGoBackpack from "./components/Bags/ReadyGo_Backpack";
import ReadyGoLunchBag from "./components/Bags/ReadyGo_LunchBag";
import ReadyGoToteBag from "./components/Bags/ReadyGo_ToteBag";
import ReadyGoClutch from "./components/Bags/ReadyGo_Clutch";
import ReadyGoSatchel from "./components/Bags/ReadyGo_Satchel";
import ReadyGoStethoscopeCase from "./components/Bags/ReadyGo_Stethoscope_Case";

/* IRG */
import IRGAll from "./components/Collections/IRG/IRGAll";
import IRGBestee from "./components/Collections/IRG/IRGBestee";
import IRGEdge from "./components/Collections/IRG/IRGEdge";
import IRGElevate from "./components/Collections/IRG/IRGElevate";
import IRGElite from "./components/Collections/IRG/IRGElite";
import IRGEPIC from "./components/Collections/IRG/IRGEPIC";
import IRGTempo from "./components/Collections/IRG/IRGTempo";
import IRGMarketingMaterials from "./components/Collections/IRG/IRGMarketingMaterials";

/* Authentication or Authorization */
import Login from "./components/Auth/Login/index";
import CustomerUsers from "./components/SubAccount/CustomerUsers";
import CustomerRoles from "./components/SubAccount/CustomerRoles";
import AddUser from "./components/SubAccount/AddUser";
import AddRole from "./components/SubAccount/AddRole";
import EditUser from "./components/SubAccount/EditUser";
import EditRole from "./components/SubAccount/EditRole";
import PasswordRequest from "./components/Auth/PasswordReset/PasswordRequest";

import Signup from "./components/Auth/Signup";
import BecomeSaller from "./components/BecomeSaller";
import Blogs from "./components/Blogs";
import Blog from "./components/Blogs/Blog.jsx";
import Contact from "./components/Contact";
import Faq from "./components/Faq";
import FlashSale from "./components/FlashSale";
import FourZeroFour from "./components/FourZeroFour";
import Home from "./components/Home";
import HomeTwo from "./components/HomeTwo";
import MarketingMaterials from "./components/MarketingMaterials";
import Careers from "./components/Careers";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ReturnPolicy from "./components/ReturnPolicy";
import ProductsCompaire from "./components/ProductsCompaire/index";
import SallerPage from "./components/SallerPage";
import Sallers from "./components/Sellers";
import SingleProductPage from "./components/SingleProductPage";
import ProductDetailPage from "./components/ProductDetailPage";
import IRGProductDetailPage from "./components/IRGProductDetailPage";
import PrintsProductDetailPage from "./components/PrintsProductDetailPage";
import AccessoryProductDetailPage from "./components/AccessoryProductDetailPage";
import TermsConditions from "./components/TermsConditions/index";
import TrackingOrder from "./components/TrackingOrder";

/* Cart */
import Wishlist from "./components/Wishlist";
import CartPage from "./components/CartPage";
import Quickorder from "./components/Quickorder";
import Checkout from "./components/OrderProcess/Checkout/index";
import CheakoutPage from "./components/CheakoutPage";
/* Order */
import OrderConfirm from "./components/OrderProcess/OrderConfirm";
import Orders from "./components/OrderProcess/Orders";
import OrderDetails from "./components/OrderProcess/OrderDetails";
/* My account */
import Dashboard from "./components/Dashboard";
import Profile from "./components/Auth/Profile";
import EmailRequest from "./components/Auth/PasswordReset/EmailRequest";
/* Accounting */
import ViewStatementTab from "./components/Dashboard/tabs/ViewStatementTab";
import PaymentConfirmTab from "./components/Dashboard/tabs/PaymentConfirmTab";
/* Order Import */
import ImportOrderFile from "./components/BulkOrder/ImportOrderFile";
import BulkOrder from "./components/BulkOrder";
import BulkOrderConfirm from "./components/BulkOrder/OrderConfirm/index";
/* Amazon */
import ConnectAmazonButton from "./components/Amazon/ConnectAmazonButton";
import ConnectSuccessAmazonButton from "./components/Amazon/ConnectSuccess";
import ConnectFailedAmazonButton from "./components/Amazon/ConnectFailed";

export default function Routers() {
  return (
    <Routes>
      {/* Home */}
      <Route exact path="/" element={<Home />} />
      <Route exact path="/home-two" element={<HomeTwo />} />
      {/* MarketingMaterials */}
      <Route
        exact
        path="/MarketingMaterials"
        element={<MarketingMaterials />}
      />
      {/* Login */}
      <Route exact path="/Login" element={<Login />} />
      {/* Password reset */}
      <Route
        exact
        path="/password-reset-emailrequest"
        element={<EmailRequest />}
      />
      <Route
        exact
        path="/password-reset-passwordrequest/:UserId/:Token"
        element={<PasswordRequest />}
      />
      {/* Promotions -EmailBlast */}
       <Route
        exact
        path="/Promotions/EmailBlast/2026_Rose_Momentum"
        element={<Promo2026_Rose_Momentum/>}
      />
       <Route
        exact
        path="/Promotions/EmailBlast/2026_Mulbery_Momentum"
        element={<Promo2026_Mulberry_Momentum/>}
      />
       <Route
        exact
        path="/Promotions/EmailBlast/2026_Allmomentum"
        element={<Promo2026_Allmomentum/>}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026_ScrubCaps"
        element={<Promo2026_ScrubCaps/>}
      />
        <Route
        exact
        path="/Promotions/EmailBlast/2026_Apr_Momentum_Labcoats"
        element={<Promo2026_Apr_Momentum_Labcoats/>}
      />
       <Route
        exact
        path="/Promotions/EmailBlast/2026_AllLabCoats"
        element={<Promo2026_AllLabCoats/>}
      />
        <Route
        exact
        path="/Promotions/EmailBlast/2026_Embrace_NewColors"
        element={<Promo2026_Embrace_NewColors />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026_JAN_SCRUPCAPS"
        element={<Promo2026_JAN_SCRUPCAPS />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026_Valentines_NEW_DROPS"
        element={<Promo2026_Valentines_NEW_DROPS />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026_ALLJACKETS"
        element={<Promo2026_ALLJACKET />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026_NB003_NB004"
        element={<Promo2026_NM003_NB004 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/2026Momentum_5005_5094"
        element={<PromoMomentum_5005_5094_2026 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/New_ReadyGo_Spring_colors_2026"
        element={<PromoNewReadyGoSpringcolors2026 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/PromoDecember2025"
        element={<PromoDecember2025 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/ReadyGo_NB003_1"
        element={<PromoReadyGo_NB003_1 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MatrixJacket_Dec2024"
        element={<PromoMatrixJacketDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MomentumJacket_Dec2024"
        element={<PromoMomentumJacketDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/RedPandaJacket_Dec2024"
        element={<PromoRedPandaJacketDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MomentumSpringColors2025"
        element={<PromoMomentumSpringColors2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MOMENTUM"
        element={<PromoMOMENTUMAug2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MATRIX_Jul2024"
        element={<PromoMATRIXJul2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/EON_Jul2024"
        element={<PromoEONJul2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/EON_MATRIX_Dec2024"
        element={<PromoEONMATRIXDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/ReadyGo_Jul2024"
        element={<PromoReadyGoJul2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/Momentum_Dec2024"
        element={<PromoMomentumDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/Promo_Dec2024"
        element={<PromoDec2024 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/SpringPastels2025"
        element={<PromoSpringPastels2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/AllNewDrops2025"
        element={<PromoAllNewDrops2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/SummerColors2025"
        element={<PromoSummerColors2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/SummerPrints2025"
        element={<PromoSummerPrints2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/newColorMomentum2025"
        element={<PromoMomentum_newColor2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/Promo_Bestee_Matrix_momentum_2025"
        element={<Promo_Bestee_Matrix_momentum_2025 />}
      />

      {/* Promotions -MainBanner */}
      <Route
        exact
        path="/Promotions/MainBanner/PromoMatrixPro_MatrixProMens"
        element={<PromoMatrixPro_MatrixProMens />}
      />
      <Route
        exact
        path="/Promotions/MainBanner/New_Spring_Colors_01"
        element={<PromoNewSpringColors01 />}
      />
      <Route
        exact
        path="/Promotions/MainBanner/Spring_Prints_02"
        element={<PromoSpringPrints02 />}
      />
      <Route
        exact
        path="/Promotions/MainBanner/Spring_Prints_03"
        element={<PromoSpringPrints03 />}
      />
      <Route
        exact
        path="/Promotions/MainBanner/Easter_Colors"
        element={<PromoEasterColors />}
      />
      <Route
        exact
        path="/Promotions/MainBanner/BlackFriday_2024_1"
        element={<PromoBlackFriday2024 />}
      />
      <Route
        exact
        path="/Promotions/Momentum_mens_focus"
        element={<PromoMomentumMensFocus />}
      />
      <Route
        exact
        path="/Promotions/Jackets_Nov2024"
        element={<PromoJacket />}
      />
      <Route
        exact
        path="/Promotions/BlackFriday_ReadyGo_Nov2024"
        element={<PromoBlackFridayReadyGo />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/AllLabcoats2025"
        element={<PromoAllLabcoats2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/PromoEmbrace2025_1"
        element={<PromoEmbrace2025_1 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/PromoEmbrace2025_2"
        element={<PromoEmbrace2025_2 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/PromoEmbrace2025_3"
        element={<PromoEmbrace2025_3 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/PromoEmbrace2025_4"
        element={<PromoEmbrace2025_4 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/PromoEmbrace2025_5"
        element={<PromoEmbrace2025_5 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/MensJune2025"
        element={<PromoMensJune2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/AllMomentum2025"
        element={<PromoAllMomentum2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/AllMomentum_Womens_Mens2025"
        element={<PromoAllMomentum_Womens_Mens2025 />}
      />
      <Route
        exact
        path="/Promotions/EmailBlast/Momentum_Embrace2025"
        element={<PromoMomentum_Embrace2025 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/Momentun_New_Colors_Spring_Summer_2026"
        element={<Momentun_New_Colors_Spring_Summer_2026 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/MatrixPro2025"
        element={<MatrixPro2025 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/JACKETS10"
        element={<JACKETS10 />}
      />

      <Route
        exact
        path="/Promotions/EmailBlast/JACKETS35"
        element={<JACKETS35 />}
      />

      {/* Promotions -MainBanner */}
      <Route exact path="/Promotions/SubBanner/EON" element={<PromoEON />} />
      {/* Collection */}
      <Route exact path="/all-products" element={<AllProductPage />} />
      <Route exact path="/Collection/Bestee" element={<Bestee />} /> 
      <Route exact path="/Collection/Blaze" element={<Blaze />} />
      <Route exact path="/Collection/BlazeLite" element={<BlazeLite />} /> 
      <Route exact path="/Collection/EaseLoungewear" element={<EaseLoungewear />} /> 
      <Route exact path="/Collection/Blossom" element={<Blossom />} />
      <Route
        exact
        path="/Collection/BlossomSignature"
        element={<BlossomSignature />}
      />
      <Route exact path="/Collection/Core" element={<Core />} />
      <Route exact path="/Collection/EON" element={<EON />} />
      <Route exact path="/Collection/EONSport" element={<EONSport />} />
      <Route exact path="/Collection/Knits" element={<Knits />} />
      <Route exact path="/Collection/LabCoat" element={<LabCoats />} />
      <Route
        exact
        path="/Collection/MatrixUnderscrub"
        element={<MatrixUnderscrub />}
      />
      <Route exact path="/Collection/Matrix" element={<Matrix />} />
      <Route exact path="/Collection/MatrixBasic" element={<MatrixBasic />} />
      <Route
        exact
        path="/Collection/MatrixImpulse"
        element={<MatrixImpulse />}
      />
      <Route exact path="/Collection/MatrixMens" element={<MatrixMens />} />
      <Route exact path="/Collection/MatrixPro" element={<MatrixPro />} />
      <Route
        exact
        path="/Collection/MatrixProMens"
        element={<MatrixProMens />}
      />
      <Route exact path="/Collection/Momentum" element={<Momentum />} />
      <Route exact path="/Collection/MomentumMens" element={<MomentumMens />} />
      <Route
        exact
        path="/Collection/MomentumLabCoats"
        element={<MomentumLabCoats />}
      />
      <Route exact path="/Collection/PrimaFlex" element={<PrimaFlex />} />
      <Route exact path="/Collection/Focus" element={<Focus />} />
      <Route exact path="/Collection/Prints" element={<Prints />} />
      <Route exact path="/Collection/PureSoft" element={<PureSoft />} />
      <Route exact path="/Collection/ReadyGO" element={<ReadyGO />} />
      <Route exact path="/Collection/RedPanda" element={<RedPanda />} />
      <Route exact path="/Collection/Smart" element={<Smart />} />
      <Route exact path="/Collection/TRUTC" element={<TRUTC />} />
      <Route exact path="/Collection/Embrace" element={<Embrace />} /> 
      {/* IRG */}
      <Route exact path="/Collection/IRGAll" element={<IRGAll />} />
      <Route exact path="/Collection/IRGBestee" element={<IRGBestee />} /> 
       <Route exact path="/Collection/Tempo" element={<IRGTempo />} />
      <Route exact path="/Collection/EPIC" element={<IRGEPIC />} />
      <Route exact path="/Collection/Edge" element={<IRGEdge />} />
      <Route exact path="/Collection/Elevate" element={<IRGElevate />} />
      <Route exact path="/Collection/Elite" element={<IRGElite />} />
      <Route
        exact
        path="/Collection/MarketingMaterials"
        element={<IRGMarketingMaterials />}
      />
      {/* Accessories */}
      <Route exact path="/Accessory/PPEProducts" element={<PPEProducts />} />
      <Route exact path="/Accessory/ScrubCap" element={<ScrubCap />} />
      <Route exact path="/Accessory/ScrunchieDuo" element={<ScrunchieDuo />} />
      <Route exact path="/Accessory/Mask" element={<Mask />} />
      {/* Bags */}
      <Route exact path="/Bags/ReadyGo" element={<ReadyGO />} />
      <Route
        exact
        path="/Bags/ReadyGo_LunchBag"
        element={<ReadyGoLunchBag />}
      />
      <Route
        exact
        path="/Bags/ReadyGo_Backpack"
        element={<ReadyGoBackpack />}
      />
        <Route
        exact
        path="/Bags/ReadyGo_ToteBag"
        element={<ReadyGoToteBag />}
      />
      <Route exact path="/Bags/ReadyGo_Clutch" element={<ReadyGoClutch />} />
      <Route exact path="/Bags/ReadyGo_Satchel" element={<ReadyGoSatchel />} />
      <Route
        exact
        path="/Bags/ReadyGo_Stethoscope_Case"
        element={<ReadyGoStethoscopeCase />}
      />
      {/* Product list as search result */}
      <Route exact path="/AllItems/:SearchTerm" element={<ProductListPage />} />
      {/*<Route exact path="/AllItems" element={<ProductListPage />} /> */}
      {/* Dropdown Headers */}
      {/* Product detail page */}
      <Route exact path="/single-product" element={<SingleProductPage />} />
      <Route
        path="/:Collection/:StyleNumber/:ColorCode/:Fit"
        element={<ProductDetailPage />}
      />
      <Route
        path="/IRG/:Collection/:StyleNumber/:ColorCode/:Fit"
        element={<IRGProductDetailPage />}
      />
      <Route
        path="/Scrubs/:Collection/:StyleNumber/:ColorCode/:Fit"
        element={<PrintsProductDetailPage />}
      />
      <Route
        path="/Accessory/:Collection/:StyleNumber/:ColorCode/:Fit"
        element={<AccessoryProductDetailPage />}
      />
      {/* Role */}
      <Route exact path="/customerroles" element={<CustomerRoles />} />
      <Route exact path="/customerusers" element={<CustomerUsers />} />
      <Route exact path="/adduser" element={<AddUser />} />
      <Route exact path="/addrole" element={<AddRole />} />
      <Route exact path="/edituser" element={<EditUser />} />
      <Route exact path="/editrole" element={<EditRole />} />
      {/* Checkout */}
      <Route exact path="/cart" element={<CartPage />} />
      <Route exact path="/quickorder" element={<Quickorder />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/orderconfirm/:CustomerPO" element={<OrderConfirm />} />
      {/* Orders */}
      <Route path="/orders" element={<Orders />} />
      <Route path="/orderdetails/:OrderId" element={<OrderDetails />} />
      {/* Payment */}
      <Route path="/paymentconfirm" element={<PaymentConfirmTab />} />
      {/* Import Order */}
      <Route exact path="/Bulkorder" element={<BulkOrder />} />
      <Route exact path="/Importorderfile" element={<ImportOrderFile />} />
      <Route
        path="/Importorderfile/Confirmation"
        element={<BulkOrderConfirm />}
      />
      {/* Statement */}
      <Route
        path="/viewStatement/:requestedNo"
        component={<ViewStatementTab />}
      />
      {/* Amazon Oauth callback process */}
      <Route path="/Amazon/ConsentUrl" element={<ConnectAmazonButton />} />
      <Route path="/connect-success" element={<ConnectSuccessAmazonButton />} />
      <Route path="/connect-failed" element={<ConnectFailedAmazonButton />} />

      <Route exact path="/checkout2" element={<CheakoutPage />} />
      <Route exact path="/wishlist" element={<Wishlist />} />
      <Route exact path="/flash-sale" element={<FlashSale />} />
      <Route exact path="/saller-page" element={<SallerPage />} />
      <Route exact path="/products-compaire" element={<ProductsCompaire />} />
      <Route exact path="/sallers" element={<Sallers />} />
      <Route exact path="/about" element={<About />} />
      <Route exact path="/blogs" element={<Blogs />} />
      <Route exact path="/blogs/blog" element={<Blog />} />
      <Route exact path="/tracking-order" element={<TrackingOrder />} />
      <Route exact path="/contact" element={<Contact />} />
      <Route exact path="/faq" element={<Faq />} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/signup" element={<Signup />} />
      <Route exact path="/profile" element={<Profile />} />
      <Route exact path="/careers" element={<Careers />} />
      <Route exact path="/myaccount" element={<Dashboard />} />
      <Route exact path="/become-saller" element={<BecomeSaller />} />
      <Route exact path="/return-policy" element={<ReturnPolicy />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route exact path="/terms-conditions" element={<TermsConditions />} />
      <Route exact path="*" element={<FourZeroFour />} />
    </Routes>
  );
}
